export default "/images/years.svg?d98392e9b82843bf869890c6259b9536";